exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Projects/ePlanner Maintenance/src/app/controllers/notification-overview/task-overview/task-overview.component.css
// module id = ../../../../../src/app/controllers/notification-overview/task-overview/task-overview.component.css
// module chunks = main